export enum UserOrganization {
  ETHOS = 'ETHOS',
  ESP = 'ESP',
  LGA = 'LGA',
  AMERITAS = 'AMERITAS',
  SENIOR_LIFE = 'SENIOR_LIFE',
  INTEGRA = 'INTEGRA',
  PROTECTIVE = 'PROTECTIVE',
  NORTH_AMERICAN = 'NORTH_AMERICAN',
}
